import { LitElement as f, unsafeCSS as c } from "lit";
import { query as v, property as s, state as y } from "lit/decorators.js";
import m from "../../shared/reset.style.css.js";
import { booleanType as d, booleanConverter as r } from "../../utils/property-types.js";
import b from "./form-checkbox.style.css.js";
import { template as k } from "./form-checkbox.template.js";
var _ = Object.defineProperty, i = (o, e, l, n) => {
  for (var a = void 0, h = o.length - 1, p; h >= 0; h--)
    (p = o[h]) && (a = p(e, l, a) || a);
  return a && _(e, l, a), a;
};
const u = class u extends f {
  constructor() {
    super(), this.label = "", this.hideLabel = !1, this.id = "", this.name = "", this.value = !1, this.disabled = !1, this.readonly = !1, this.required = !1, this.checked = !1, this.tabIndex = 0, this.variant = "default", this.indeterminate = !1, this.defaultValue = this.value, this._defaultId = `dss-checkbox-${crypto.randomUUID()}`, this.internals = this.attachInternals();
  }
  static get styles() {
    return [c(m), c(b)];
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
  updated(e) {
    e.has("value") && typeof this.value == "string" && ((this.value === "" || this.value === "false") && (this._input.checked = !1), this.internals.setFormValue(this._input.checked ? this.value : null)), !e.has("checked") && e.has("value") && typeof this.value == "boolean" && (this._input.checked = this.value, this.internals.setFormValue(this._input.checked ? "on" : null)), e.has("checked") && typeof this.value == "boolean" && this.internals.setFormValue(this._input.checked ? "on" : null), e.has("indeterminate") && (this._input.indeterminate = this.indeterminate);
  }
  formDisabledCallback(e) {
    this.disabled = e;
  }
  formResetCallback() {
    const e = typeof this.defaultValue == "boolean";
    this.value = e ? !1 : this.defaultValue, this._input.checked = !1, this.checked = !1;
  }
  formStateRestoreCallback(e) {
    this.value = e ?? "";
  }
  focusInput() {
    var e;
    (e = this._input) == null || e.focus();
  }
  async firstUpdated() {
    await this.updateComplete, this.defaultValue = this.value, (this.checked || this.value === !0 || this.value === "true") && (this.checked = !0, this._input.checked = !0, this.internals.setFormValue(this._input.checked ? typeof this.value == "string" ? this.value : "on" : null));
  }
  render() {
    return k(this);
  }
  _handleChange(e) {
    this.checked = e.target.checked, typeof this.value == "boolean" && (this.value = this.checked), this.internals.setFormValue(this.checked ? typeof this.value == "string" ? this.value : "on" : null), this._emitChange();
  }
  _getEffectiveId() {
    return this.id !== "" ? this.id : this._defaultId;
  }
  _emitChange() {
    this.dispatchEvent(new Event("change", { bubbles: !0, composed: !0 }));
  }
  focus(e) {
    const l = { ...e, focusVisible: !0 };
    if (this._input) {
      this._input.focus(l);
      return;
    }
    this.updateComplete.then(() => {
      var n;
      (n = this._input) == null || n.focus(l);
    });
  }
};
u.formAssociated = !0;
let t = u;
i([
  v("input.dss-checkbox-input")
], t.prototype, "_input");
i([
  s({ type: String })
], t.prototype, "label");
i([
  s(d)
], t.prototype, "hideLabel");
i([
  s({ type: String })
], t.prototype, "id");
i([
  s({ type: String })
], t.prototype, "name");
i([
  s({ type: String })
], t.prototype, "value");
i([
  s({ converter: r, reflect: !0 })
], t.prototype, "disabled");
i([
  s({ converter: r, reflect: !0 })
], t.prototype, "readonly");
i([
  s({ converter: r, reflect: !0 })
], t.prototype, "required");
i([
  s({ converter: r, reflect: !0 })
], t.prototype, "checked");
i([
  s({ type: Number })
], t.prototype, "tabIndex");
i([
  s({ type: String })
], t.prototype, "variant");
i([
  s(d)
], t.prototype, "indeterminate");
i([
  y()
], t.prototype, "defaultValue");
export {
  t as FormCheckbox
};
//# sourceMappingURL=form-checkbox.js.map
